import styled from 'styled-components';

import { StyledActionButton as DefaultStyledActionButton } from './external-incentive-details.styled.default';

export * from './external-incentive-details.styled.default';

export const StyledActionButton = styled(DefaultStyledActionButton)`
  font-size: 1.125rem;
  justify-content: center;

  width: 100%;

  ${Styles.desktop} {
    width: auto;
  }
`;
